var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFtmBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4760_14572)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.975 42.7313L68.9 35.775V49.6875L56.975 42.7313ZM68.9 72.5438L53 81.8188L37.1 72.5438V56.3125L53 65.5875L68.9 56.3125V72.5438ZM37.1 35.775L49.025 42.7313L37.1 49.6875V35.775ZM54.9875 46.0438L66.9125 53L54.9875 59.9563V46.0438ZM51.0125 59.9563L39.0875 53L51.0125 46.0438V59.9563ZM66.9125 32.4625L53 40.4125L39.0875 32.4625L53 24.1813L66.9125 32.4625ZM33.125 31.1375V74.5313L53 85.7938L72.875 74.5313V31.1375L53 19.875L33.125 31.1375Z",
    fill: "url(#paint0_linear_4760_14572)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4760_14572",
    x1: 53,
    y1: 19.875,
    x2: 53,
    y2: 85.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4760_14572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtmBackdrop);
export default __webpack_public_path__ + "static/media/ftmBackdrop.a2445e69398c5f94d5113ed7c7128adc.svg";
export { ForwardRef as ReactComponent };